var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrokenHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.3627 20.5684C39.0227 23.2084 37.5294 25.555 36.6461 27.7884L43.8227 34.975C44.1352 35.2876 44.3107 35.7114 44.3107 36.1534C44.3107 36.5953 44.1352 37.0191 43.8227 37.3317L36.1794 44.975C35.8669 45.2876 35.6914 45.7114 35.6914 46.1534C35.6914 46.5953 35.8669 47.0191 36.1794 47.3317L39.9994 51.155",
    stroke: "#6F706F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0319 66.6902C44.4108 67.4036 43.645 67.9766 42.7854 68.3712C41.9258 68.7658 40.992 68.973 40.0462 68.979C39.1003 68.985 38.164 68.7897 37.2995 68.406C36.435 68.0223 35.662 67.459 35.0319 66.7535L16.6719 48.9802C11.6719 43.9802 6.67188 38.3135 6.67188 30.6469C6.67127 26.9373 7.79603 23.3147 9.89757 20.2578C11.9991 17.2009 14.9786 14.8534 18.4423 13.5255C21.9061 12.1975 25.6913 11.9516 29.2978 12.8202C32.9043 13.6887 36.1624 15.6309 38.6419 18.3902C39.0117 18.7356 39.4986 18.9279 40.0046 18.9286C40.5105 18.9292 40.9979 18.738 41.3685 18.3935C43.8478 15.6345 47.1057 13.6924 50.7118 12.8237C54.318 11.955 58.1029 12.2007 61.5665 13.5282C65.0302 14.8557 68.0096 17.2027 70.1114 20.2591C72.2132 23.3155 73.3385 26.9376 73.3385 30.6469C73.3385 38.2802 68.3385 43.9802 63.3385 48.9802L45.0319 66.6902Z",
    stroke: "#6F706F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenHeart);
export default __webpack_public_path__ + "static/media/broken-heart.27423cffb2b588b332eda011b2ac441b.svg";
export { ForwardRef as ReactComponent };